import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { TicketDetailedFill } from "react-bootstrap-icons";
import { fetchTicket } from "../services/TicketService";
import { Ticket } from "../components/Ticket";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { AccountPageHeader } from "../components/AccountPageHeader";

export function TicketView() {
  const { id } = useParams();

  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const data = await fetchTicket(id);
        if (!cancelled) setTicket(data);
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [id]);

  if (loading) return <LoadingSpinner />;
  if (error)   return <p className="tv-load-error">Failed to load ticket: {error}</p>;

  return (
    <div className="tv-page">
      <AccountPageHeader
        icon={<TicketDetailedFill />}
        title={`Ticket #${id}`}
        breadcrumbs={[{ to: '/tickets', label: 'Support Tickets' }]}
      />
      <Ticket data={ticket} />
    </div>
  );
}
